if (!customElements.get('pdp-club-toggle')) {
	class PdpClubToggle extends HTMLElement {
		connectedCallback() {
			this.form = this.querySelector('form');
			this.trigger = this.querySelector('[data-pdp-club-trigger]');
			this.loading = false;
			this.routes = (window.FoxThemeSettings && window.FoxThemeSettings.routes) || {};

			if (this.form) {
				this.form.addEventListener('submit', (evt) => {
					evt.preventDefault();
					this.toggle();
				});
			} else if (this.trigger) {
				this.trigger.addEventListener('click', (evt) => {
					evt.preventDefault();
					this.toggle();
				});
			}

			if (window.FoxThemeEvents && typeof window.FoxThemeEvents.subscribe === 'function') {
				window.FoxThemeEvents.subscribe('ON_ITEM_ADDED', () => this.syncFromCart());
			}

			this.watchExternalDisable();

			this.broadcast(this.classList.contains('is-active'));
		}

		watchExternalDisable() {
			// Les apps bundle (Biscuits) désactivent les boutons d'ajout tant que le
			// bundle est incomplet. La carte Club doit rester ajoutable en permanence.
			if (!this.trigger || typeof MutationObserver !== 'function') return;

			this.enableTrigger();
			this.disableObserver = new MutationObserver(() => this.enableTrigger());
			this.disableObserver.observe(this, {
				subtree: true,
				attributes: true,
				attributeFilter: ['disabled', 'aria-disabled'],
			});
		}

		enableTrigger() {
			this.querySelectorAll('[data-pdp-club-trigger]').forEach((trigger) => {
				if (trigger.hasAttribute('disabled')) trigger.removeAttribute('disabled');
				if (!this.loading && trigger.getAttribute('aria-disabled') === 'true') {
					trigger.removeAttribute('aria-disabled');
				}
			});
		}

		disconnectedCallback() {
			if (this.disableObserver) this.disableObserver.disconnect();
		}

		async toggle() {
			if (this.loading) return;
			const active = this.classList.contains('is-active');
			this.setLoading(true);
			try {
				if (active) {
					await this.removeFromCart();
					this.setActive(false);
				} else {
					await this.addToCart();
					this.setActive(true);
				}
			} catch (error) {
				console.error('[pdp-club-toggle]', error);
				this.notifyError(error.message);
			} finally {
				this.setLoading(false);
			}
		}

		async addToCart() {
			const formData = new FormData();
			formData.append('id', this.dataset.variantId);
			formData.append('quantity', '1');
			formData.append('isClubCard', 'true');
			if (this.dataset.variantSku) {
				formData.append('properties[_EAN13]', this.dataset.variantSku);
			}
			formData.append('properties[_proginovSKU]', `_proginovSKU:${this.dataset.proginovId || ''}`);

			const sections = this.cartSections();
			if (sections.length) {
				formData.append('sections', sections.join(','));
				formData.append('sections_url', window.location.pathname);
			}

			const response = await fetch(this.routes.cart_add_url || '/cart/add.js', {
				method: 'POST',
				headers: {
					Accept: 'application/javascript',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: formData,
			});
			const data = await response.json();

			if (data.status) {
				throw new Error(data.description || data.message || 'Impossible d’ajouter la carte Club.');
			}

			if (window.FoxThemeEvents && typeof window.FoxThemeEvents.emit === 'function' && data.sections) {
				window.FoxThemeEvents.emit('ON_ITEM_ADDED', data);
			} else {
				this.renderCartSections(data.sections);
			}
			this.refreshCartCount();
		}

		async removeFromCart() {
			const response = await fetch(this.routes.cart_change_url || '/cart/change.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: JSON.stringify({
					id: String(this.dataset.variantId),
					quantity: 0,
					sections: this.cartSections(),
					sections_url: window.location.pathname,
				}),
			});
			const state = await response.json();

			if (state.errors) {
				throw new Error(typeof state.errors === 'string' ? state.errors : 'Impossible de retirer la carte Club.');
			}

			this.renderCartSections(state.sections);
			const drawer = document.querySelector('cart-drawer');
			if (drawer && typeof state.item_count === 'number') {
				drawer.classList.toggle('is-empty', state.item_count === 0);
			}
			if (typeof state.item_count === 'number') {
				this.updateCartCount(state.item_count);
			} else {
				this.refreshCartCount();
			}
		}

		renderCartSections(sections) {
			const drawer = document.querySelector('cart-drawer');
			if (!drawer || !sections || typeof drawer.getSectionsToRender !== 'function') return;

			drawer.getSectionsToRender().forEach((section) => {
				const target = section.selector
					? document.querySelector(section.selector)
					: document.getElementById(section.id);
				const html = sections[section.id];
				if (!target || !html) return;

				const parsed = new DOMParser().parseFromString(html, 'text/html');
				const source = parsed.querySelector(section.selector || '.shopify-section');
				if (source) target.innerHTML = source.innerHTML;
			});
		}

		cartSections() {
			const drawer = document.querySelector('cart-drawer');
			if (!drawer || typeof drawer.getSectionsToRender !== 'function') return [];
			return drawer.getSectionsToRender().map((section) => section.id);
		}

		refreshCartCount() {
			if (!window.FoxThemeCartHelpers) return;
			window.FoxThemeCartHelpers.getState().then((state) => {
				this.updateCartCount(state.item_count);
			});
		}

		updateCartCount(count) {
			if (window.FoxThemeCartHelpers && typeof window.FoxThemeCartHelpers.updateCartCount === 'function') {
				window.FoxThemeCartHelpers.updateCartCount(count);
			}
		}

		async syncFromCart() {
			try {
				const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
				const cart = await response.json();
				const inCart = cart.items.some(
					(item) => String(item.variant_id || item.id) === String(this.dataset.variantId)
				);
				if (inCart !== this.classList.contains('is-active')) {
					this.setActive(inCart);
				}
			} catch (error) {
				console.error('[pdp-club-toggle] sync', error);
			}
		}

		setActive(active) {
			this.classList.toggle('is-active', active);
			this.querySelectorAll('[data-pdp-club-trigger]').forEach((trigger) => {
				trigger.setAttribute('aria-pressed', String(active));
				trigger.setAttribute(
					'aria-label',
					active ? 'Retirer la carte Club du panier' : 'Ajouter la carte Club au panier'
				);
			});
			this.broadcast(active);
			this.syncLegacyForms(active);
		}

		broadcast(active) {
			document.body.classList.toggle('pdp-club-price-active', active);
			document.dispatchEvent(new CustomEvent('pdp:club-toggle', { detail: { active } }));
		}

		syncLegacyForms(active) {
			document.querySelectorAll('.club-card-form').forEach((form) => {
				form.classList.toggle('in-cart', active);
				const addButton = form.querySelector('[name="add"]');
				if (addButton) addButton.disabled = active;
			});
		}

		setLoading(loading) {
			this.loading = loading;
			this.classList.toggle('is-loading', loading);
			if (this.trigger) {
				if (loading) {
					this.trigger.setAttribute('aria-disabled', 'true');
				} else {
					this.trigger.removeAttribute('aria-disabled');
				}
			}
		}

		notifyError(message) {
			if (window.FoxTheme && window.FoxTheme.Notification) {
				window.FoxTheme.Notification.show({
					target: document.body,
					method: 'appendChild',
					type: 'warning',
					message: message || 'Une erreur est survenue.',
					last: 3000,
					sticky: true,
				});
			}
		}
	}

	customElements.define('pdp-club-toggle', PdpClubToggle);
}
